<template>
  <navigate-detail :is-edit='false'>
  </navigate-detail>
</template>

<script>
import NavigateDetail from '../components/NavigateDetail'
export default {
  name: 'CreateNavigate',
  components: {
    NavigateDetail
  }
}
</script>
